import React, { FC } from 'react'

import { HomeAccelerationCardCmsContent } from 'core/services/cms/interfaces'

import { ProductFeatureCard } from '../../../../components/product-feature-card/ProductFeatureCard'
import { ProcessingFeatureCard } from '../processing-feature-card/ProcessingFeatureCard'

import classes from './style.module.scss'

interface AccelerationCardsProps {
  cards: HomeAccelerationCardCmsContent[]
}

const isProcessingCard = (card: HomeAccelerationCardCmsContent): boolean => {
  return Boolean(card.statPrefix || card.statValue || card.statSuffix)
}

export const AccelerationCards: FC<AccelerationCardsProps> = ({ cards }) => {
  return (
    <div className={classes.container}>
      {cards.map((card, index) => {
        if (isProcessingCard(card)) {
          return (
            <ProcessingFeatureCard
              key={index}
              className={classes.processingCard}
              content={card}
            />
          )
        }

        return (
          <ProductFeatureCard
            key={index}
            icon={card.iconUrl}
            text={card.title}
            className={classes.productCard}
          />
        )
      })}
    </div>
  )
}
